import { Component, OnInit, OnDestroy } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})

export class BlogComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public loading: boolean;
  public blogContent;
  public errorMessage: string;

  constructor(private blogService: BlogService) { }

  ngOnInit(): void {
    this.getBlogs();
  }

  getBlogs() {
    var query = "?filterByDisable=false&filterByStatus=true";
    this.blogService.getBlogListwithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe(data => {        
      this.loading = false;
      this.blogContent = data.data.items;
    },
    err => {
      this.errorMessage = err.error.message;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}